import { OnInit, EventEmitter, Output, Component, Input } from '@angular/core';
import { DataVehiculosService } from '../../../modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service';
import { PageChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { FormGroup, FormControl } from '@angular/forms';
import { Vendor } from '../../../../core/interfaces/vendor';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { PageInfo } from '../../../../core/interfaces/paginacion';
import { SortDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'dms-vendors-modal',
    templateUrl: './vendors-dialog.component.html',
    styleUrls: ['./vendors-dialog.component.scss']
})



export class VendorsModalComponent implements OnInit {

    @Input() pantalla: string;
    totalPages: number;
    total: number;
    objetoPaginacion: PageInfo;
    @Output() childVendorClose = new EventEmitter<any>();
    isLoadingVendor: boolean;
    error: string;
    code: string;
    subtitle: string;
    filtroGrid: any[] = [];
    datosOrigen20filtro: any[] = [];
    hasPage: boolean;
    formGeneric = new FormGroup({
        searchInput: new FormControl()
    });

    selectedSearch: any;

    public gridView: GridDataResult;
    searchValue: any;
    datosOrigen: Vendor[] = [];
    public pageSize: number;
    public pageNumber: number;
    public skip: number;
    constructor(
        private toastr: ToastrService,
        private _dataVehiculosService: DataVehiculosService) {
        this.subtitle = 'labels.seguros';
        this.skip = 0;
        this.pageNumber = 1;
        this.pageSize = 20;
        this.objetoPaginacion = {
            'skip': this.skip,
            'Number': this.pageNumber,
            'Size': this.pageSize

        };


        this.searchValue = '';
    }
    dataTable: any[] = [
        {
            title: '',
            th: ['labels.vendedor', 'labels.name'],
            fields: ['VENDORCODE', 'Name'],
            width: ['50', '50'],
            format: ['', ''],
            height: '250'
        }];
    sort: SortDescriptor[] = [{
        field: 'VENDORCODE',
        dir: 'asc'
    }
    ];
    ngOnInit() {

        this.datosIniciales();



        this.formGeneric.get('searchInput').valueChanges.subscribe(val => {
            if (val.length > 2) {
                this.searchValue = val;

                this.datosIniciales();
            }
        });
    }


    datosIniciales() {

        this.isLoadingVendor = true;
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VendorsService.svc/GetAll`;
        const params = {
            'searchValue': this.searchValue,
            'pageInfo': {
                'skip': this.objetoPaginacion.skip,
                'Number': this.objetoPaginacion.Number,
                'Size': this.objetoPaginacion.Size
            }
        };


        this._dataVehiculosService.getVendor(_URL_, params).subscribe(data => {
            const auxData = data.Response.Content;

            this.objetoPaginacion = data.Response.pageInfo;

            if (auxData) {
                this.datosOrigen = auxData;

                this.rellenarTabla(this.datosOrigen, this.objetoPaginacion);
            }
            this.isLoadingVendor = false;
        });
    }
    rellenarTabla(items, objetoPaginacion) {

        this.totalPages = objetoPaginacion.TotalPages; // total de paginas
        this.total = objetoPaginacion.TotalElements; // total de elementos
        this.dataTable[0]['gridView'] = {
            data: items,
            total: this.total
        };


    }
    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.pageSize = event.take;
        this.pageNumber = 1;
        if (event) {
            this.pageNumber = event.skip / this.pageSize + 1;
        } else {
            this.skip = 0;
        }
        this.objetoPaginacion = {
            'skip': this.skip,
            'Number': this.pageNumber,
            'Size': this.pageSize
        };



        this.datosIniciales();
    }


    isvalidVal(valor) {
        if (valor !== null && valor !== undefined) {
            return true;
        } else {
            return false;
        }
    }

    search() {
        this.searchValue = this.formGeneric.get('searchInput').value;
        if (this.isvalidVal(this.searchValue)) {

        } else {
            this.searchValue = '';
        }
        this.datosIniciales();
    }


    closeVendors() {
        this.childVendorClose.emit('cerrar');
    }



    getRow(event) {
        this.childVendorClose.emit(event.dataItem);
    }





}
